import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Team from "@/pages/Team";
import Branches from "@/pages/Branches";
import Contact from "@/pages/Contact";
import Portal from "@/pages/Portal";
import PortalAdmin from "@/pages/PortalAdmin";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/portal/admin" element={<PortalAdmin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #E5E5E5",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
